import React, { useState, useEffect, useContext } from 'react';
import {
  BORDER,
  SELECTED_TAB_KEY,
  TAB_BORDER,
  USERTYPES,
} from '../../constants/Constants';
import { Tab, TabList } from '@fluentui/react-tabs';


import { t } from 'i18next';
import userContext from '../../context/users/UserContext';
import themeContext from '../../context/theme/ThemeContext';
import PacsQueueTab from './PacsQueueTab';
import PacsQueueList from './PacsQueueList';
import CustomBreadCrumb from '../../components/CustomBreadCrumb';
import { breadCrumbItems, tabDetails } from './Helper';

const PacsQueue = () => {
  const { roles, username, loadByUsername, authenticated } =
    useContext(userContext);
  const { getThemeColor } = useContext(themeContext);
  const [selectedValue, setSelectedValue] = useState(
    SELECTED_TAB_KEY.PACSQUEUE + '1'
  );

  useEffect(() => {
    if (!authenticated) {
      console.log('--- Authentication again ----');
      loadByUsername();
      return;
    }
  }, [authenticated]);

  
  const onTabSelect = (event, data) => {
    let currentTab = data.value;
    console.log('currentTab->', currentTab);
    document.getElementById(currentTab).style.border = getThemeColor('border');
    document.getElementById(currentTab).style.borderBottom = 'unset';
    document.getElementById(currentTab).style.borderRadius =
      '10px 10px 0px 0px';
    const tabDetail =tabDetails(selectedValue);
    for (let i = 1; i <= tabDetail.length; i++) {
      if (currentTab.charAt(currentTab.length - 1) != i) {
        document.getElementById(
          SELECTED_TAB_KEY.PACSQUEUE + `${i}`
        ).style.border = '';
        document.getElementById(
          SELECTED_TAB_KEY.PACSQUEUE + `${i}`
        ).style.borderRadius = '';
        document.getElementById(
          SELECTED_TAB_KEY.PACSQUEUE + `${i}`
        ).style.borderBottom = '';
      }
    }
    setSelectedValue(data.value);
  };

  useEffect(() => {
    if (
      document.getElementById(SELECTED_TAB_KEY.PACSQUEUE + '1') != null
    ) {
      document.getElementById(
        SELECTED_TAB_KEY.PACSQUEUE + '1'
      ).style.border = getThemeColor('border');
      document.getElementById(
        SELECTED_TAB_KEY.PACSQUEUE + '1'
      ).style.borderBottom = 'unset';
      document.getElementById(
        SELECTED_TAB_KEY.PACSQUEUE + '1'
      ).style.borderRadius = '10px 10px 0px 0px';
    }
  }, [document.getElementById(SELECTED_TAB_KEY.PACSQUEUE + '1')]);

  return (
    <>
      {roles?.length > 0 && (
        <div className="main-container-body">
          <div className="breadCrumb">
            <CustomBreadCrumb items={breadCrumbItems} />
          </div> 
          <div
            style={{
              padding: '0px 3px',
              marginTop: '10px',
              boxSizing: 'border-box',
              height: 'calc(100% - 101px)',
            }}
          >
            {
              <PacsQueueTabSection
                onTabSelect={onTabSelect}
                selectedValue={selectedValue}
                tabDetails={tabDetails}
              />
            }
            <div
              style={{
                borderBottom: getThemeColor('border'),
                width: '100%',
                boxSizing: 'border-box',
              }}
            ></div>
            {<PacsQueueList selectedValue={selectedValue} />}
          </div>
        </div>
      )}
    </>
  );
};

export default PacsQueue;

const PacsQueueTabSection = ({ onTabSelect, selectedValue, tabDetails }) => {
  const getTabActiveStatus = (tabId) => {
    if (selectedValue === tabId) return true;
    return false;
  };

  return (
    <TabList
      style={{ marginLeft: '10px' }}
      className="tab-list-container-cmp tabList"
      defaultSelectedValue={SELECTED_TAB_KEY.PACSQUEUE + '1'}
      selectedValue={selectedValue}
      onTabSelect={onTabSelect}
    >
      {tabDetails(selectedValue).map((tabElement, index) => {
        return (
          <Tab
            key={index}
            className="top-tab-cmp"
            id={SELECTED_TAB_KEY.PACSQUEUE + (index + 1).toString()}
            value={SELECTED_TAB_KEY.PACSQUEUE + (index + 1).toString()}
          >
            {
              <PacsQueueTab
                title={tabElement.title}
                icon={tabElement.icon}
                contentClass={tabElement.contentClass}
                active={getTabActiveStatus(tabElement.id)}
              />
            }
          </Tab>
        );
      })}
    </TabList>
  );
};
